import Stack from "@mui/material/Stack/Stack";
import React from "react";
import { Receipt } from "../../../../../../../domain/models/receipt-model";
import { ReceiptCard } from "../../../Components/ReceiptCard";
import { Total } from "../../../../Components/Total";

type Props = {
  receipts: Receipt[];
  onClick: (id: number) => void;
  onSeeReport: (id: number) => void;
};

export const Main: React.FC<Props> = ({ receipts, onClick, onSeeReport }) => {
  return (
    <>
      <Total text="Total de Entradas" number={receipts.length.toString()} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        {receipts.map((receipt) => {
          return (
            <ReceiptCard
              receipt={receipt}
              key={receipt.id}
              onStart={onClick}
              onSeeReport={onSeeReport}
            />
          );
        })}
      </Stack>
    </>
  );
};
